// import "./App.css";
import "./App.css";

import { Text, Center } from "@react-three/drei";
import * as THREE from "three";
export default function Loading() {
  return (
    <>
      <Text color="black" fontSize={0.3}>
        loading...
      </Text>
    </>
  );
}
